export default __webpack_public_path__ + "static/media/blobs-no-1.7cf46b9f.mid";